/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentRunAnswer {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentRunAnswer.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentRunAnswer>): WellArchitectedFrameworkAssessmentRunAnswer {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentRunAnswer(), model);
        WellArchitectedFrameworkAssessmentRunAnswer.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentRunAnswer>): WellArchitectedFrameworkAssessmentRunAnswer {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentRunAnswer.newInstance(<WellArchitectedFrameworkAssessmentRunAnswer> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentRunAnswer) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentRunAnswer.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentRunAnswer): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentRunAnswer.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.createdOn === "string") {
            this.createdOn = new Date(<string><any>this.createdOn);
        }
    }

    /**
     * Identity of the Best Practice
     */
    best_practice_id: string;

    /**
     * Status of the question or best practice
     */
    status: models.WellArchitectedFrameworkAssessmentRunAnswerStatus;

    /**
     * User ID of user who provided this answer
     */
    createdBy: string;

    /**
     * When the answer was provided
     */
    createdOn: Date;

    /**
     * User ID of the owner of this answer
     */
    owner: string;

    /**
     * List of user IDs assigned to this answer
     */
    assigned_to: Array<string>;

    /**
     * List of Attachment IDs assigned to this answer
     */
    attachment_ids: Array<string>;

    /**
     * Unique ID for this comment
     */
    comment_id: string;

    /**
     * Comment added to this answer
     */
    comment: string;

    /**
     * Markdown text of the recommendation if edited by the user
     */
    recommendation: string;

    /**
     * Sync failure reason
     */
    sync_failure_reason: string;

}
